/**
 * Стейт пользователя
 * @type {{isAuthorized: boolean, user: null}}
 */
const userState = {
  isAuthorized: false,
  hasSubscription: null,
  user: null,
};

export default userState;



// WEBPACK FOOTER //
// ./daily/assets/id/userState.js